






















































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import HospitalizedLine from './HospitalizedLine.vue'
import MultipleInputs from '@/utils/MultipleInputs'
const MULTI_FIELD = 'hosIds'
const MAX_NUM = 10
const YI_ZHUAN_YUAN = 1
const ICU = 2

@Component({
	components: {
		HospitalizedLine,
	},
})
export default class HospitalizedInfo extends Vue {
	private YI_ZHUAN_YUAN = YI_ZHUAN_YUAN
	private tagList = [
		{
			id: YI_ZHUAN_YUAN,
			tagName: '伤者已转院',
			desc: '伤者多次转院需记录多次',
		},
		{
			id: ICU,
			tagName: 'ICU/重症监护室',
			desc: '伤者在重症监护室时勾选',
		},
	]
	private multiInstance: any = {}

	private MAX_NUM = MAX_NUM
	private MULTI_FIELD = MULTI_FIELD

	@Prop({})
	private form!: any

	@Prop({})
	private hospitalizedSofar!: any

	@Prop({})
	private canEdit!: any

	private multiAdd(index: number) {
		const res = this.multiInstance.add()
		if (res === false) {
			this.$message.error(`住院信息限制${MAX_NUM}条内`)
		} else {
			this.form.setFieldsValue({ [`${MULTI_FIELD}`]: res })
		}
	}

	private multiRemove(index: number) {
		const res = this.multiInstance.remove(index)
		if (res !== false) {
			this.form.setFieldsValue({ [`${MULTI_FIELD}`]: res })
		}
	}

	public beforeDestroy() {
		this.form.resetFields([MULTI_FIELD])
	}

	public getForm() {
		const hosChecked = this.form.getFieldValue('hospitalizedTag')
		let hosInfo: any = {
			icu: hosChecked && hosChecked.includes(ICU) ? '1' : '0',
			transferHospital:
				hosChecked && hosChecked.includes(YI_ZHUAN_YUAN) ? '1' : '0',
		}

		return new Promise((resolve, reject) => {
			if (hosInfo.transferHospital === '1') {
				// 校验住院情况
				const idArr = this.form.getFieldValue(MULTI_FIELD)
				let count = 0
				hosInfo.inHospitalList = []
				idArr.forEach(async (id: number) => {
					const hospitalizedLine: any = ((this.$refs[`hospitalizedLine${id}`] ||
						[]) as any)[0]
					try {
						const lineForm: any = await hospitalizedLine.getForm()
						hosInfo.inHospitalList.push(lineForm)
						if (++count === idArr.length) {
							resolve(hosInfo)
						}
					} catch (err) {
						reject(err)
					}
				})
			} else {
				resolve(hosInfo)
			}
		})
	}

	public created() {
		this.form.getFieldDecorator(MULTI_FIELD, {
			initialValue: [],
			preserve: true,
		})
		this.multiInstance = new MultipleInputs(1, MAX_NUM)
		this.form.setFieldsValue({ [`${MULTI_FIELD}`]: this.multiInstance.idArr })
	}
}
